import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const City = () => {
  const { t, errors, city, showAddressFields } = useAddress()

  if (!showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('city', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.readonly_city')}
        currentValue={city}
        readOnly={true}
        disabled={true}
      />
    </FormControl>
  )
}

export default City
